import { render, staticRenderFns } from "./Den_details.vue?vue&type=template&id=9c9ba278&"
import script from "./Den_details.vue?vue&type=script&lang=js&"
export * from "./Den_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports